package com.tixforgigs.common.ui.components.mandarin

import com.tixforgigs.common.core.theme.Styles
import io.kvision.core.Container
import io.kvision.html.h1
import io.kvision.html.h2
import io.kvision.html.h3
import io.kvision.panel.vPanel

/**
 * generic mandarin title, including
 * @param title
 * @param subtitle
 * */
fun Container.mandarinTitle(
  title: String? = null,
  subtitle: String? = null
) {
  vPanel {
    title?.let {
      mandarinTitle(title)
    }
    subtitle?.let {
      mandarinSubtitle(subtitle)
    }
  }
}

/**
 * generic mandarin headline, including
 * @param headline
 * @param subheadline
 * */
fun Container.mandarinHeadline(
  headline: String? = null,
  subheadline: String? = null
) {
  vPanel {
    headline?.let {
      mandarinHeadline(headline)
    }
    subheadline?.let {
      mandarinSubHeadline(subheadline)
    }
  }
}

private fun Container.mandarinTitle(
  titleText: String,
) {
  h1(className = Styles.MandarinClasses.TITLE) { +titleText }
}

private fun Container.mandarinSubtitle(
  titleText: String,
) {
  h2(className = Styles.MandarinClasses.SUBTITLE) { +titleText }
}

private fun Container.mandarinHeadline(
  titleText: String,
) {
  h2(className = Styles.MandarinClasses.HEADLINE) { +titleText }
}

private fun Container.mandarinSubHeadline(
  titleText: String,
) {
  h3(className = Styles.MandarinClasses.SUBHEADLINE) { +titleText }
}